prismanoteApp.controller('retailerGiftCardImportController', ['$scope', '$rootScope', '$api', 'Upload', '$q', '$timeout', '$retailer', '$diamond', '$productConfig', '$shop',
  function ($scope, $rootScope, $api, Upload, $q, $timeout, $retailer, $diamond, $productConfig, $shop) {
    $scope.s3_location = ''
    $scope.access = false
    $scope.autoGenerated = false

    $scope.checkRetailerIsValidOrNot = function (currentShop, user) {
      console.log('$rootScope', $rootScope)
      console.log('Current User', user)
      var hasAcces = localStorage.getItem('retailerImport') == 'true'
      if (user && user.email && (user.email == 'retailer1@prismanote.com' || user.email == 'jolmer@excellent-electronics.nl' || user.email == 'jolmer1@excellent-electronics.nl' || user.email == 'niek@juwelierbos.nl' || user.email == 'info@nvo.media' ||
        hasAcces)) {
        $scope.access = true
        $scope.currentShop = $rootScope.currentShop
      } else {
        $scope.access = false
      }
    }

    $scope.changeAutoGenerateStatus = function (autoGenerated) {
      console.log(' Auto Generated ', autoGenerated)
      $scope.giftCard.autoGenerated = autoGenerated
    }

    $scope.step = []
    $scope.step[1] = true
    $scope.percent = 0
    $scope.back = function (step) {
      goToStep(step)
    }

    $scope.gemDKinds = $diamond.getGemKinds()
    $scope.gemDPurities = $diamond.getGemPurities()
    $scope.gemDColors = $diamond.getGemColors()
    $scope.gemDCuts = $diamond.getGemCuts()

    $scope.dialSColors = $productConfig.getDialColors()
    $scope.strapSColors = $productConfig.getStarpColors()
    $scope.caseSColors = $scope.jewelColors = Object.assign($scope.dialSColors, $scope.strapSColors)

    $scope.variantBases = $productConfig.variantBases()

    function goToStep (step) {
      $scope.alert = null

      angular.forEach($scope.step, function (value, key) {
        $scope.step[key] = false
      })

      $scope.step[step] = true

      if (step == 1) {
        $scope.percent = 0
      } else if (step == 2) {
        $scope.percent = 33
      } else if (step == 3) {
        $scope.percent = 66
      } else if (step == 4) {
        $scope.percent = 100
      }
    }

    $scope.completeStep1 = function (importFile, delimiter) {
      $scope.importFile = importFile
      $scope.delimiter = delimiter

      if (!importFile) {
        $scope.alert = {
          type: 'danger',
          msg: 'Geen of onjuist bestand gekozen'
        }
      } else {
        $scope.loading = true

        uploadFile({
          importFile: importFile,
          delimiter: $scope.delimiter,
          publish: $scope.publish
        }, 'api/import/parse')
          .then(function (response) {
            $scope.s3_location = response.data.uploadedResponse.Location

            $scope.loading = false

            $scope.headers = []
            $scope.giftCard = {

            }

            var i = 0
            angular.forEach(response.data.headers, function (value, key) {
              if (value) {
                var format = /[!@#$%^&*()+\=\[\]{};:"\\|,<>\/?]/
                value = value.trim()
                if (format.test(value) == false) {
                  var header = {
                    name: value
                  }
                  $scope.headers.push(header)
                } else {
                  value = value.replace(/[!@#$%^&*.-_()+\=\[\]{};:"\\|,<>\/?]/g, '').replace(/ /g, '').trim()
                  var header = {
                    name: value
                  }
                  $scope.headers.push(header)
                }
              }

              if (i == (response.data.headers.length - 1)) {
                $scope.lineCount = response.data.data.lines
                $scope.giftCardProperties = response.data.product
                goToStep(2)
              }

              i++
            })
          })
          .catch(function (reason) {
            console.error('Error while parsing', reason.data)
            $scope.alert = {
              type: 'danger',
              msg: 'upload error: ' + reason.data.message
            }
            $scope.loading = false
          })
      }
    }

    $scope.completeStep2 = function () {
      goToStep(3)
      $scope.percent = 66
      $scope.step3()
    }

    var getItems = function (type) {
      $api.get(type, { getAll: true })
        .then(function (response) {
          $scope[type] = response.data[type]
          console.log('Brands ========>', $scope[type])
        }).catch(function (reason) {
          console.log(reason)
        })
    }

    $scope.getBrands = function (shopNameSlug) {
      console.log('----------- Get Brands -----------', shopNameSlug)
      $shop.getshopbrandsForProduct($rootScope.currentShop.nameSlug)
        .then(function (response) {
          if (response.brands.length > 0) {
            $scope.brands = response.brands
            console.log('Brands =======>>>>>>>>>>', $scope.brands)
          } else {
            $scope.brands = []
          }
        })
        .catch(function (err) {
          console.error('Error while getting products', err)
        })
    }

    var searchItems = function (str, type) {
      var matches = []
      $scope[type].forEach(function (item) {
        if (item._id) {
          if ((item._id.en.name.toLowerCase().indexOf(str.toString().toLowerCase()) >= 0) || (item._id.en.nameSlug.toLowerCase().indexOf(str.toString().toLowerCase()) > 0)) {
            matches.push(item)
          }
        }
      })
      return matches
    }

    $scope.searchBrands = function (str) {
      return searchItems(str, 'brands')
    }

    $scope.getTaxForShop = function (currentShopId) {
      $shop.getTaxForShop(currentShopId)
        .then(function (tax) {
          console.log('Getting Tax Rat', tax)
          if (tax && tax.taxes && tax.taxes.rates) {
            $scope.taxes = tax.taxes.rates
            for (var i = 0; i < 91; i++) $scope.taxes.push({ name: i, rate: i })
          } else {
            $scope.taxes = []
            for (var i = 0; i < 91; i++) $scope.taxes.push({ name: i, rate: i })
          }
        })
        .catch(function (errorInGettingTax) {
          console.error('Error In Getting Tax For Shop', errorInGettingTax)
        })
    }

    $scope.brandSelected = function (selected) {
      console.log('SELECTED BRAND : ', selected)
      $scope.mySelectedBrandTitle = selected.title
      $scope.mySelectedBrandIsPoolArticle = selected.originalObject.isPoolArticleBrand
      var brand = {
        _id: selected.originalObject._id,
        name: selected.title,
        nameSlug: selected.originalObject.nameSlug,
        description: selected.originalObject.description,
        images: selected.originalObject.images,
        isPoolArticleBrand: selected.originalObject.isPoolArticleBrand,
        startingDigits: (selected.originalObject._id.startingDigits  && selected.originalObject._id.startingDigits != 'null' && selected.originalObject._id.startingDigits != 'undefined' && selected.originalObject._id.startingDigits != 'NULL' ) ? selected.originalObject._id.startingDigits : null 
      }

      $scope.brandnames[this.$parent.$index].value = brand
    }

    $scope.step3 = function () {
      if ($scope.giftCard.vat) {
        getValues('vat', function (err, result) {
          console.log(result)
          $scope.vats = result
          console.log('Vats', $scope.vats)
        })
      }

      if ($scope.giftCard.isRedeemed) {
        getValues('isRedeemed', function (err, result) {
          console.log(result)
          $scope.isRedeemeds = result
          console.log('isRedeemeds', $scope.isRedeemeds)
        })
      }
    }

    $scope.completeStep3 = function () {
      console.log('giftCard', $scope.giftCard)
      uploadFile({
        importFile: $scope.importFile,
        delimiter: $scope.delimiter,
        giftCard: $scope.giftCard,
        customData: {
          vats: $scope.vats ? $scope.vats : null,
          isRedeemeds: $scope.isRedeemeds ? $scope.isRedeemeds : null
        },
        lines: $scope.lineCount,
        s3FileLocation: $scope.s3_location
      }, 'api/import/handle')
        .then(function (response) {
          goToStep(4)
        })
        .catch(function (reason) {
          console.log(reason)
          $scope.alert = {
            type: 'danger',
            msg: 'upload error: ' + reason.status
          }
        })
    }

    function getValues (value, callback) {
      console.log('Check Value', value, $scope.giftCard)
      var property = JSON.parse(_.get($scope.giftCard, value))
      var columnName = property.name

      uploadFile({
        importFile: $scope.importFile,
        delimiter: $scope.delimiter,
        column: columnName
      }, 'api/import/value')
        .then(function (response) {
          console.log('response', response)
          return callback(null, response.data.result)
        })
        .catch(function (reason) {
          console.log('reason', reason)
          return callback(reason)
        })
    }

    $scope.completeImport = function () {
      console.log('handleImport', $scope.giftCard)

      uploadFile({
        importFile: $scope.importFile,
        delimiter: $scope.delimiter,
        product: $scope.giftCard
      },
      'api/import/handle')
        .then(function (response) {
          console.log(response.data)
        })
        .catch(function (reason) {
          $scope.alert = {
            type: 'danger',
            msg: 'upload error: ' + reason.status
          }
          $scope.error = true
        })
    }

    $scope.closeAlert = function () {
      $scope.alert = null
    }

    function uploadFile (data, url) {
      //console.log('$rootScope.currentShop below in the controller', $rootScope.currentShop)

      var params = {
        url: url,
        data: {
          delimiter: data.delimiter,
          cat: data.category,
          file: data.importFile,
          currentShopId: $rootScope.currentShop._id,
          giftCard: data.giftCard ? data.giftCard : null,
          column: data.column ? data.column : null,
          customData: data.customData ? data.customData : null,
          lines: data.lines ? data.lines : null
        }
      }

      console.log('Calling Upload with following params:', params)
      return $q(function (resolve, reject) {
        console.log('Into the upload function')
        Upload.upload(params)
          .then(function (res) {
            console.log('Response from upload ', res)
            $timeout(function () {
              resolve(res)
            })
          }, function (res) {
            // wanneer uploaden mislukt
            console.error('Error: ', res.status)
            reject(res)
          }, function (evt) {
            // tijdens upload
            // var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            // $scope.uploadProgress = progressPercentage;
            // console.log("Progress: " + progressPercentage + '%' + evt.config.data);
          })
      })
    }
  }])
